var importWithRetry = function (importFunc, retryDelay, maxRetries) {
    if (retryDelay === void 0) { retryDelay = 3000; }
    if (maxRetries === void 0) { maxRetries = 3; }
    var retries = 0;
    var importModule = function () {
        return importFunc().catch(function (error) {
            if (retries >= maxRetries) {
                throw error;
            }
            else {
                console.warn("Failed to import module. Retrying in ".concat(retryDelay / 1000, " seconds..."));
                retries++;
                return new Promise(function (resolve) { return setTimeout(resolve, retryDelay); }).then(importModule);
            }
        });
    };
    return importModule();
};
export default importWithRetry;
